import { Box, Checkbox } from '@mui/material'
import React from 'react'
import TextBox from './TextBox'
import FilterAltIcon from '@mui/icons-material/FilterAlt'

const ContainsFilter = (props) => {
    const { onBlur = () => { }, onChange = () => { }, disabled = false, value = '', isSelect = false, onCheckboxChange = () => { }, checked = false, onKeyDown = () => { } } = props
    return (
        <Box className='containsFilter filterTextBox22'>
            {isSelect ? <Box className='tableBodyCheckBox'> <Checkbox
                checked={checked}                // controlled by parent
                onChange={(e) => onCheckboxChange(e.target.checked)} // notify parent
                disabled={disabled}
            /></Box>
                : <TextBox placeholder='Contains' value={value} onBlur={onBlur} onChange={onChange} disabled={disabled} onKeyDown={onKeyDown} />}
            <FilterAltIcon sx={{ color: '#AAAAAA', width: '16px', height: '16px', fontSize: '16px' }} />
        </Box>
    )
}

export default ContainsFilter